import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_TIME_SINK_IDS } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const TIME_SINK_ENUM_VALUES = [...AGENT_ONBOARDING_TIME_SINK_IDS];

const META: Meta = {
  description: "The picked outcome's reply starts streaming in the agent panel",
  name: 'agent_onboarding_spotlight_shown',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The winning time sink whose reply is streaming',
      name: 'outcome',
      required: true,
      type: 'enum',
      values: TIME_SINK_ENUM_VALUES,
    },
    {
      description: 'The scripted preview that outcome resolves to',
      name: 'resolved_preview_id',
      required: true,
      type: 'enum',
      values: TIME_SINK_ENUM_VALUES,
    },
  ],
};

export default META;
